import { render, staticRenderFns } from "./MedicalRequirementsPlanForm.vue?vue&type=template&id=3192cedb&scoped=true&"
import script from "./MedicalRequirementsPlanForm.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192cedb",
  null
  
)

export default component.exports